import { IStudentTermsDatasource } from './../datasources/student_terms_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-user-app').factory(
  'loadStudentTermsCommand',
  (
    $http: ng.IHttpService,
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngStudentTermsDatasource: IStudentTermsDatasource
  ): ICommand => {
    return defineCommand(
      'loadStudentTermsCommand',
      (deferred: ng.IDeferred<IQuery[]>): ng.IPromise<void> => {
        return $http({
          method: 'GET',
          url: 'catalog/term/',
          params: {
            is_displayable: true,
            is_enabled: true
          }
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            ngStudentTermsDatasource.write(response.data.results);
            QueryMediator.runQueries(ngStudentTermsDatasource);
          })
          .catch(deferred.reject);
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/load_student_terms_command.ts